import React from "react";
import stringHelpers from "../helpers/stringHelpers";
import parser from "html-react-parser";

const TextWithAside = ({ text, asides }) => {
  const asideTagReplacement = (text, asides) => {
    asides.forEach((item, index) => {
      const itemTitleLevel = item?.titleLevel ?? "h2";
      const regex = new RegExp(`\\[aside${index + 1}\\]`, "g");
      const asideElementHtml = `<${itemTitleLevel}>${
        item?.title ?? ""
      } <div class="tps-aside grid-x tps-float-medium tps-float-right">
      <div class="tps-aside-inner cell">
        <div class="tps-aside-title h2">${item?.subTitle ?? ""}</div>
        <div
          class="tps-aside-text">${stringHelpers.imagePathReplace(item?.text)}
        </div>
      </div>
    </div>
    </${itemTitleLevel}>`;
      text = text.replace(regex, asideElementHtml);
    });

    return text;
  };

  const element = (
    <div className="tps-editable-text cell margin-bottom-3">
      <div>
        {parser(
          asideTagReplacement(stringHelpers.imagePathReplace(text), asides)
        )}
      </div>
    </div>
  );

  return element;
};

export default TextWithAside;
